import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { logout } from "../../../features/auth";
import { ICustomObjectDocuments } from "../../../models/storeModels/ICustomObjectDocuments";

function getInitialState(){
    const initialState: ICustomObjectDocuments = {
        documents: null,
    }
    return initialState;
}

export const customObjectDocumentsSlice = createSlice({
    name: 'customObjectDocuments',
    initialState: getInitialState(),
    reducers: {
        setCustomObjectDocuments(state, action: PayloadAction<any>) {
            state.documents = action.payload
        }
    },
    extraReducers: (builder) => {
        builder.addCase(logout, () => {
            return getInitialState()
        })
    },
})

export const {
    setCustomObjectDocuments,
} = customObjectDocumentsSlice.actions
export const customObjectDocumentsReducer = customObjectDocumentsSlice.reducer;
